import { AddRuleModal } from "./AddRuleModal";
import { Button } from "@/components/ui/button";
import { ComponentProps } from "react";
import { FieldStatus } from "components/form-control/field.type";
import { PolicyRuleInput } from "types";
import { callAll } from "helper/utils";
import clsx from "clsx";
import { formatValueUnit } from "helper/policy";
import useToggle from "hooks/use-toggle";

export interface RuleItemProps extends ComponentProps<"button"> {
  status?: FieldStatus;
  rule: PolicyRuleInput;
  onChangeValue: (timeSpan: PolicyRuleInput) => void;
  className?: string;
  name?: string;
  placeholder?: string;
}

export const RuleItem = ({ onChangeValue, rule, className, onClick, ...buttonProps }: RuleItemProps) => {
  const [showPopup, setShowPopup] = useToggle();

  const onApply = (input: PolicyRuleInput) => {
    onChangeValue(input);
    setShowPopup();
  };

  return (
    <>
      <div className="flex flex-col w-full">
        <Button
          className={clsx("w-full h-full", className)}
          {...buttonProps}
          onClick={callAll(onClick, setShowPopup)}
          variant="ghost"
          type="button"
        >
          <div className="flex flex-col text-xs text-left w-full">
            <span className="h-5 flex-1 truncate text-left">Activity: {rule.activity}</span>
            <span className="h-5 flex-1 truncate text-left">
              Stay: {formatValueUnit(rule.maxStay, rule.maxStayUnit)}
            </span>
            <span className="h-5 flex-1 truncate text-left">
              No return: {formatValueUnit(rule.noReturn, rule.noReturnUnit)}
            </span>
            <span className="h-5 flex-1 truncate text-left">User classes: {rule.userClasses?.join(", ")}</span>
            <span className="h-5 flex-1 truncate text-left">Rates:</span>
            {rule.rate?.map((item, idx) => (
              <div key={`rule-rate-${idx}`} className="flex flex-col items-start ml-2">
                <div>Rate: {item.rate + " " + item.rateUnit + " - " + (item.rateUnitPeriod || 0)}</div>
                <div>Increment duration: {item.incrementDuration}</div>
                <div>Increment amount: {item.incrementAmount}</div>
                <div>Duration: {(item.startDuration || 0) + " - " + (item.endDuration || 0)}</div>
              </div>
            ))}
          </div>
        </Button>
      </div>

      {showPopup && <AddRuleModal isOpen={showPopup} ruleData={rule} onApply={onApply} onDismiss={setShowPopup} />}
    </>
  );
};
